import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';
import { CHART_COLORS } from '../constants';
import PropTypes from 'prop-types';

const UserPerformanceChart = ({ data }) => {
    if (!data) return null;

    // Calculate max win percentage and add 10% padding
    const maxWinPercentage = Math.max(...data.map(user => user.win_percentage));
    const domainMax = Math.min(100, Math.ceil(maxWinPercentage + 5));

    return (
        <div className="chart-container user-performance-chart">
            <h3>User Performance</h3>
            <ResponsiveContainer width="100%" height={450}>
                <BarChart
                    data={data}
                    layout="vertical"
                    margin={{ top: 5, right: 30, left: 80, bottom: 5 }}
                    barSize={20}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        stroke={CHART_COLORS.grid}
                    />
                    <XAxis
                        type="number"
                        domain={[0, domainMax]}
                        tick={{ fill: CHART_COLORS.text }}
                    />
                    <YAxis
                        type="category"
                        dataKey="username"
                        width={90}
                        tick={{
                            fill: CHART_COLORS.text,
                            fontSize: '11px'
                        }}
                        interval={0}
                    />
                    <Tooltip
                        formatter={(value, name) => {
                            if (name === "win_percentage") return `${value}%`;
                            return String(value);
                        }}
                        contentStyle={{
                            backgroundColor: CHART_COLORS.background,
                            border: `1px solid ${CHART_COLORS.grid}`,
                            color: '#ffffff'
                        }}
                        cursor={{
                            fill: 'rgba(255, 255, 255, 0.1)',
                            radius: 2
                        }}
                        labelStyle={{ color: '#ffffff' }}
                        itemStyle={{ color: '#ffffff' }}
                    />
                    <Bar
                        dataKey="win_percentage"
                        name="Win Rate"
                    >
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${entry.username}`}
                                fill={entry.win_percentage >= 55 ? CHART_COLORS.win : CHART_COLORS.loss}
                                fillOpacity={0.9}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

UserPerformanceChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        username: PropTypes.string.isRequired,
        win_percentage: PropTypes.number.isRequired
    })).isRequired
};

export default UserPerformanceChart;
